import React from 'react'
import Collaborative from '../Collaborative/component/Collaborative'
import DualDegree from '../Collaborative/component/DualDegree'
import Programmes from '../Collaborative/component/Programmes'
import PartnerUniversities from '../Collaborative/component/PartnerUniversities'
const CollaborativePage = () => {
  return (
    <>
    <Collaborative/>
    <DualDegree/>
    <Programmes/>
    <PartnerUniversities/>
    </>
  )
}

export default CollaborativePage